import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class CustomValidators {
    public static lettersOnlyValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ ]*$/gi;
            if (!patron.test(control.value)) {
                return { 'lettersOnlyError': 'No se permiten espacios adicionales, numeros o caracteres especiales' };
            }
            return null;
        };
    }
    public static lettersOnlyCodeValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-ZñÑ\/]+$/gi;
            if (!patron.test(control.value)) {
                return { 'lettersOnlyCodeError': 'No se permiten espacios adicionales, numeros o caracteres especiales' };
            }
            return null;
        };
    }

    public static lettersNumberOnlyValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-Z0-9 ]+$/gi;
            if (!patron.test(control.value)) {
                return { 'lettersNumberOnlyError': 'No se permiten caracteres especiales, solo letras, números y espacios' };
            }
            return null;
        };
    }

    public static lettersNumberOnlyValidatorEsp(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^([a-zA-Z0-9\sÁÉÍÓÚáéíóúÑñ]+)$/gi;
            if (!patron.test(control.value)) {
                
                return { 'lettersNumberOnlyValidatorEsp': 'No se permiten carateres especiales, solo letras, números y espacios' };
            }
            return null;
        };
    }


    public static numbersOnlyValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[0-9]+$/gi;
            if (!patron.test(control.value)) {
                return { 'numberError': 'No se permiten caracteres especiales, solo letras, números y espacios' };
            }
            return null;
        };
    }
    public static numbersOrEmptyValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[0-9]*$/gi;
            if (control.value !=null && !patron.test(control.value)) {
                return { 'numberError': 'No se permiten caracteres especiales, solo letras, números y espacios' };
            }
            return null;
        };
    }
    public static DateValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-Z0-9/ ]+$/gi;
            if (!patron.test(control.value)) {
                return { 'dateError': 'No se permiten caracteres especiales a excepción de "/"' };
            }
            return null;
        };
    }
    public static lettersOnlySiglaValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-Z0-9]+$/gi;
            if (!patron.test(control.value)) {
                return { 'lettersOnlySiglaError': 'No se permiten espacios adicionales, ni caracteres especiales' };
            }
            return null;
        };
    }

    public static NumbersNoRepeatedValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^(?!.*(.)\1{4}).*([a-zA-ZñÑáéíóúÁÉÍÓÚ\s0-9])+$/;
            if (!patron.test(control.value)) {
                if(control.value == ""){
                    return null
                }
                return { 'NumbersNoRepeatedError': 'No se permite la secuencia de 5 números repetidos' };
            }
            return null;
        };
    }

    public static SpacesNoRepeatedValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^((?!\s{2}).)+$/;
            if (!patron.test(control.value)) {
                return { 'SpacesNoRepeatedError': 'No se permiten espacios en blanco consecutivos' };
            }
            return null;
        };
    }

    public static NoWhiteEspacesAllowedValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^\S*$/;
            if (!patron.test(control.value)) {
                return { 'NoWhiteEspacesAllowedError': 'No se permiten espacios en blanco' };
            }
            return null;
        };
    }

    public static NoDoubleSpaceAllowedValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[\wñÑ&]+( [\wÑñ&]+)*$/;
            if (!patron.test(control.value)) {
                return { 'NoDoubleSpaceAllowedValidator': 'No se permiten espacios al inicio o al final del valor ingresado, ni doble espacios' };
            }
            return null;
        };
    }

    public static AmpersandValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[\w&ñÑ ]+$/gi;
            if (!patron.test(control.value)) {
                return { 'AmpersandError': 'No se permiten espacios o caracteres especiales a excepción de "&"' };
            }
            return null;
        };
    }

    public static AmpersandEmptyValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^[a-zA-Z0-9& ]+$/gi;
            let patronEmpty = /^ *$/;
            if (!patron.test(control.value) && !patronEmpty.test(control.value)) {
                return { 'AmpersandError': 'No se permiten espacios o caracteres especiales a excepción de "&"' };
            }
            return null;
        };
    }

    public static emptyTextValidator(): ValidatorFn {
        let ErrorBool;
        return (control: AbstractControl): ValidationErrors | null => {
            const controlValue = control.value
            ErrorBool = false
            if (controlValue != undefined && typeof controlValue === "string") {
                controlValue.trim() == "" ? ErrorBool = true : ErrorBool = false;
                return controlValue.trim() == "" ? { 'emptyError': "No se permiten solo espacios." } : null;
            }
            else {
                ErrorBool = false
                return null
            }

        };

    }
    public static emailValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^(([^<>()+[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|.+")@((\[\d{1,3}.\d]{1,3}\.\d{1,3}\.\d{1,3}])|(([\w\-]+\.)+[a-zA-Z]{2,}))$/gi
            if (!patron.test(control.value)) {
                return { 'emailError': 'Debe ingresar un email válido' };
            }
        };
    }

    public static HtmlValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /[<>]/;
            if (patron.test(control.value)) {
                return { 'htmlError': 'No puede ingresar texto que este entre <>' };
            }
        };
    }

    public static decimalValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let patron = /^\d+$/;
            if (!patron.test(control.value)) {
                return { 'decimalError': 'No se permiten valores decimales' };
            }
            return null;
        };
    }
}